module.exports = __webpack_public_path__ + "search-no-38b4096c.png";